import { createCustomEnum } from "./customEnum";

const PartnerTypes = createCustomEnum({
	Association: {
		value: 6,
		name: "Association",
		displayName: "Association",
	},
	AuroraHouseAccount: {
		value: 15,
		name: "AuroraHouseAccount",
		displayName: "Aurora House Account",
	},
	BusinessDevelopment: {
		value: 5,
		name: "BusinessDevelopment",
		displayName: "Business Development",
	},
	InsideSalesAgent: {
		value: 3,
		name: "InsideSalesAgent",
		displayName: "Inside Sales Agent",
	},
	InsideSalesManager: {
		value: 4,
		name: "InsideSalesManager",
		displayName: "Inside Sales Manager",
	},
	ISV: {
		value: 8,
		name: "ISV",
		displayName: "ISV",
	},
	NA_AuroraUser: {
		value: 11,
		name: "NA_AuroraUser",
		displayName: "N/A - Aurora User",
	},
	NA_MerchantUser: {
		value: 12,
		name: "NA_MerchantUser",
		displayName: "N/A - Merchant User",
	},
	OutsideSalesAgent: {
		value: 0,
		name: "OutsideSalesAgent",
		displayName: "Outside Sales Agent",
	},
	OutsideSalesAgentIndependent: {
		value: 13,
		name: "OutsideSalesAgentIndependent",
		displayName: "Outside Sales Agent (Independent)",
	},
	OutsideSalesManager: {
		value: 1,
		name: "OutsideSalesManager",
		displayName: "Outside Sales Manager",
	},
	OutsideSalesOfficeHqAccount: {
		value: 14,
		name: "OutsideSalesOfficeHqAccount",
		displayName: "Outside Sales Office HQ Account",
	},
	ReferralPartner: {
		value: 7,
		name: "ReferralPartner",
		displayName: "Referral Partner",
	},
	Other: {
		value: 10,
		name: "Other",
		displayName: "Other",
	},
});

export default PartnerTypes;
